import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import Homestay from '../../../../../models/Homestay.js';
import { withTranslation } from "react-i18next";
import { Icon, Popconfirm, Rate, Tooltip } from 'antd';
import Ripple from '../../../common/component/Ripple';
import Modal from '../../../common/component/Modal';
import { PATHS } from '../../../../../constants/Define';
import { FlagIcons } from '../../../common/component/TranslateButton';
import EllipsisText from '../../../common/component/EllipsisText';

const ListCols = ['name', 'code', 'address', 'star', 'review', 'isActive', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new Homestay());
class HomestayList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    width: 150,
                    key: 'name',

                },
                code: {
                    width: 100,
                    key: 'code',
                    align: 'center',
                },
                address: {
                    width: 150,
                    key: 'address',
                    align: 'left',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                // types: {
                //     width: 100,
                //     key: 'type',
                //     render: (types, record) => types.map(type => this.props.t(`item.homestay.${type}`)).join(', '),
                // },
                star: {
                    width: 180,
                    key: 'star',
                    align: 'center',
                    render: (star, record) => <Rate disabled value={star} allowHalf />,
                },
                review: {
                    width: 100,
                    key: 'review',
                    align: 'left',
                },
                isActive: {
                    width: 100,
                    key: 'active',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.homestay.active') : this.props.t('item.homestay.deActive')} />
                    )
                },
                translations: {
                    key: 'translations',
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    // fixed: 'right',
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
            syncHomestayId: ''
        };
    }

    static getDerivedStateFromProps(nextProps, prevState){
        if((nextProps.isFetchSync !== prevState.isFetchSync) && !nextProps.isFetchSync ){
           return { syncHomestayId: '' };
       }
       else return null;
     }

    render() {
        const { loading, pagination, homestays } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="homestay-list"
                scroll={{ x: 1200 }}
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(homestays || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'homestay'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                classChildren="p-0" classParent="m-0"
            />
        );
    }

    handleSync = (homestayId) => {
        this.setState({ syncHomestayId: homestayId })
        this.props.syncRates(homestayId)
    }

    renderEditComponent(item) {
        const { t, permisions, permissionRate } = this.props;
        const { syncHomestayId } = this.state;
        const removeItem = () => {
            return this.props.onDeleteHomestay && this.props.onDeleteHomestay(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.homestay.title`)),
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Fragment>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={Func.getPathWithParams(PATHS.HOMESTAY.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
                {/* {
                    permisions && permisions.allowDelete &&
                    <Ripple onClick={onRemove}><Icon type="delete" className="fs20 colorPrimary" /></Ripple>
                } */}

                {
                    permissionRate && permissionRate.allowSync &&
                    <Tooltip title={this.props.t(`action.sync`)} placement="top">
                      <Popconfirm
                        title={t('item.rate.confirmSync')}
                        onConfirm={() => this.handleSync(item.id)}
                        onCancel={() => {}}
                        okText={t(`action.sync`)}
                        cancelText={t(`action.cancel`)}
                      >
                        <Ripple disabled={item.id === syncHomestayId} >
                            <Icon 
                                style={{ color: '#2269A6' }}  
                                type="sync" 
                                className="fs20" 
                                spin={item.id === syncHomestayId} 
                            />
                        </Ripple>
                      </Popconfirm>
                        
                    </Tooltip>
                }
            </Fragment>
        )
    }


}

export default withTranslation()(HomestayList);
